import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LogoService} from "../../services/LogoService";
import {ORG_LOGO_CSS, TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ToastService} from "../../services/Toast.service";
import {NumeralService} from "../../services/Numeral.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {LoadingService} from "../../services/LoadingService";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {ExportService} from "../../services/Export.service";
import {Session} from "../../services/Session";
import {ColorListComponent} from "./color-list/color-list.component";
import {FormatAmountPipe} from "../../pipes/format-amount.pipe";
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import {FeatureFlagService} from "../../tpiq-services/feature-flag.service";
import { SVG_TEMPLATES } from './theme-templates';

declare let _: any;
declare const jQuery: any;
declare const moment: any;

@Component({
  selector: 'app-client-plan-report',
  standalone: true,
  imports: [CommonModule, FormsModule, ColorListComponent, FormatAmountPipe],
  templateUrl: './client-plan-report.component.html',
  styleUrl: './client-plan-report.component.scss'
})
export class ClientPlanReportComponent implements OnInit, OnDestroy {
  org: string;
  user: any;
  orgName: string;
  orgLogo: string;
  backgroundColor: string;
  
  @Input() clientTaxplanData: any;
  @Input() clientsList: any;
  @Input() taxYear: any;
  @Input() bgColor: any;
  @Input() associatedData: any;
  @Input() stateAssociatedData: any;
  @Input() taxPlanId: any;
  @Input() roiGraphFilter: any;
  @Input() readOnly: any;
  @Input() planYear: any;

  destroy$: EventEmitter<void> = new EventEmitter<void>();
  reveal: any = {
    introLetter: false,
    roiFees: false
  };
  introLetter: any = {
    description: ''
  };
  listOfStrategies: Array<any> = [];
  strategyData: any;
  editorOptions = {
    heightMin: 200,
    heightMax: 250,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Introduction',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
  };
  hasActualVsPLannedGraphData = false;
  groupedActualVsPLannedChartOptions: any;
  chartColors: Array<any> = ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'];
  hasROIGraphData = false;
  groupedROIChartOptions: any;
  roiGraphData: any;
  filterYears: Array<any> = [];
  reportData: any;
  @ViewChildren('clientoverview') clientOverview!: any;
  @ViewChildren('clientresources') clientResources!: any;
  @ViewChildren('todotemplate') todoTemplates!: any;
  @ViewChildren('introduction') introduction!: any;

  /* customize report changes */
  showReportCustomize: boolean = true;
  selectedThemeColor = '#64B5F6';
  selectedThemeSecColor = '#110646';
  selectedTextColor = '#333333';
  hasReset = true;
  @ViewChild('reportCustomize') reportCustomize: ElementRef;
  top_height: any;
  selectedThemeName = '';
  introPageBgUrl = '';
  contentPageBgUrl = '';
  themeColorsArray: Array<any> = ['#64b5f6', '#c8e6c9', '#ff9800', '#4caf50', '#1f4e79', '#bdbdbd', '#800020', '#080707', '#ffd700', '#228b22'];
  themeColorsSecArray: Array<any> = ['#64b5f6', '#c8e6c9', '#ff9800', '#4caf50', '#1f4e79','#bdbdbd', '#800020'];
  textColorsArray: Array<any> = ['#333333'];
  backgroundType = 'cover';
  strategiesForExport: any;
  layout1Url = 'https://static.taxplaniq.com/report-assets/theme1/bg';
  layout2Url = 'https://static.taxplaniq.com/report-assets/theme2/bg';
  layout3Url = '';
  logoBg: any;
  topMainSvg: SafeStyle;
  contentSvg: SafeStyle;
  orgCSS: any = ORG_LOGO_CSS;
  disclaimer : any;
  disclaimerApiPost : any;
  totalSavings: number = 0;
  costLines: Array<any> = [];
  allTaskDetails: any[] = [];
  allToDoDetails: any[] = [];
  availableThemes = ['theme1', 'theme2', 'theme3'];
  totalThirdPartyFees: number = 0;
  totalInvestedAmount: number = 0;
  overviewStatus: boolean = false;
  todoTaskStatus: boolean = false;
  themeMap: Record<string, string> = {
  theme1: 'theme4',
  theme2: 'theme5',
  theme3: 'theme6'
};
  


  constructor(
    private logoService: LogoService,
    private loadingService: LoadingService,
    private taxPlanningService: TaxPlanningService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private exportService: ExportService,
    private numeralService: NumeralService,
    private sanitizer: DomSanitizer,
    private featureFlag: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.org = Session.getOrg();
    this.user = Session.getUser('delegatedFrom');
    this.orgName = this.user.org || '';
    this.orgLogo = this.logoService.getLoginLogoUrl();
    this.backgroundColor = this.bgColor ? this.bgColor : '#fff';
    this.logoBg = {
      background: 'url("' + this.orgLogo + '") center center no-repeat',
      'background-size': 'contain',
      'height': '5rem',
      'width': '25rem'
    };

    const cssArray = this.orgCSS[this.org];
    if (cssArray) {
      _.each(cssArray, (obj) => {
        this.logoBg[obj.style] = obj.value;
      });
    }

    if (this.clientTaxplanData && this.clientTaxplanData.strategies && this.clientTaxplanData.strategies.length === 1) {
      if (this.clientTaxplanData.strategies[0].id === null) {
        this.clientTaxplanData.strategies = [];
      }
    }

    this.listOfStrategies = (this.clientTaxplanData) ? this.clientTaxplanData.strategies : this.listOfStrategies;
    this.restoreOverviewStatusFromSession();
    
    this.strategiesInRowsOfThree();
    this.getReportCustomizationThemes();
    this.fillYears();
    this.getROIGraphData();
    this.getActualVsPlannedGraphData();
    this.getStrategiesInformation();
    this.getDesclaimerDetails();
    const clientName = (this.clientTaxplanData) ? this.clientTaxplanData.userName : '';
    const defaultIntroLetter = 'Dear ' + clientName + ', Please find your enhanced tax strategy report, enclosed for review.';
    this.introLetter.description = (this.clientTaxplanData && this.clientTaxplanData.introLetter) ? this.clientTaxplanData.introLetter : defaultIntroLetter;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  get isReportingV2Enabled() : boolean {
    return this.featureFlag.isEnabled('enableReportingV2');
  }

  getDesclaimerDetails(){
    this.taxPlanningService.getTaxPlanningSummary(this.org, this.user.id, this.clientTaxplanData.id, 'Category', this.planYear) .subscribe(response => {
      this.disclaimer =  response.disclaimer;
      this.disclaimerApiPost = response.disclaimer;

       if(response.costlines && response.costlines.length >0){
        this.costLines = response.costlines || [];
        this.totalThirdPartyFees = this.costLines.reduce(
          (sum, line) => sum + (line.amount || 0),
          0
        );
      }
    });
  }

  getStrategiesInformation() {
    const base = this;
    const data = _.map(this.listOfStrategies, 'strategyId');
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getPlanStrategiesData(this.org, this.user.id, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.strategyData = response;
        this.setAssociatedRateForStrategy();
        this.setStateAssociatedRateForStrategy();
        this.reportData = [];
        _.each(this.listOfStrategies, function (strategy) {
          let strategyDataTemp = _.find(base.strategyData, {id: strategy.strategyId});
          strategyDataTemp = {...strategyDataTemp, planAmount: (strategy.actualAmount > 0)? strategy.actualAmount: strategy.amount, associatedRate: strategy.associateRate,
            taxSavings: strategy.roiAmount, goalDate: strategy.goalDate, associatedRateName: strategy.associateRateName,
            stateTaxSavings: strategy.stateRoiAmount, stateAssociatedRate: strategy.stateAssociateRate, stateAssociatedRateName: strategy.stateAssociateRateName, actualAmount: strategy.actualAmount, amountType: strategy.amountType ?? "",
            taskDetails: strategy.taskDetails, toDoDetails: strategy.toDoDetails, investedAmount: strategy.investedAmount, estimatedSavings: (strategy.roiAmount || 0) + (strategy.stateRoiAmount || 0), reportCustomText: strategy.reportCustomText};
          const obj = _.find(base.clientsList, {id: strategy.clientId});
          strategyDataTemp.relatedParty = (obj) ? obj.name : '';
          strategyDataTemp.name = (strategyDataTemp.name);
          // Calculate total savings
          const savings = (strategyDataTemp.taxSavings || 0) + (strategyDataTemp.stateTaxSavings || 0);
          base.totalSavings += savings;
          base.totalInvestedAmount += strategy.investedAmount;

          // Use this strategy's own taskDetails/toDoDetails when present; otherwise fall back
          // to its legacy checklists/clientTodos so the strategy detail section matches Implementation Overview.
          const resolvedTaskDetails = (strategyDataTemp.taskDetails && strategyDataTemp.taskDetails.length > 0)
            ? strategyDataTemp.taskDetails
            : (strategyDataTemp.checklists || []).map(task => ({...task, title: task.name}));
          const resolvedToDoDetails = (strategyDataTemp.toDoDetails && strategyDataTemp.toDoDetails.length > 0)
            ? strategyDataTemp.toDoDetails
            : (strategyDataTemp.clientTodos || []).map(ctd => ({name: ctd.name, dueDate: ''}));
          strategyDataTemp.taskDetails = resolvedTaskDetails;
          strategyDataTemp.toDoDetails = resolvedToDoDetails;

          base.reportData.push(strategyDataTemp);

          resolvedTaskDetails.forEach(task => {
            base.allTaskDetails.push({
              ...task,
              strategyName: strategyDataTemp.name
            });
          });

          resolvedToDoDetails.forEach(todo => {
            base.allToDoDetails.push({
              ...todo,
              strategyName: strategyDataTemp.name
            });
          });
        });
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get plan strategies data');
      });
  }

  setAssociatedRateForStrategy() {
    const base = this;
    _.each(this.listOfStrategies, function (strategy) {
      const rates = base.associatedData[strategy.strategyId] || [];
      const obj = _.find(rates, {id: strategy.associatedWith});
      if (obj){
        if (obj.name == 'Effective Rate'){
          strategy['associateRate'] = base.clientTaxplanData.effectiveRate;
          strategy['associateRateName'] = obj.name;
        } else if (obj.name == 'Marginal Rate'){
          strategy['associateRate'] = base.clientTaxplanData.marginalRate;
          strategy['associateRateName'] = obj.name;
        } else if (obj.name == 'Cap Gain Rate'){
          strategy['associateRate'] = base.clientTaxplanData.capGainRate;
          strategy['associateRateName'] = obj.name;
        } else if (obj.name == 'C Corp Flat Rate'){
          strategy['associateRate'] = base.clientTaxplanData.ccropFlatRate;
          strategy['associateRateName'] = obj.name;
        } else if (obj.name == 'Market Growth Rate'){
          strategy['associateRate'] = base.clientTaxplanData.marketGrowthRate || 5;
          strategy['associateRateName'] = obj.name;
        } else if (obj.name == 'SE Tax Rate'){
          strategy['associateRate'] = base.clientTaxplanData.seTaxRate || 15.3;
          strategy['associateRateName'] = obj.name;
        } else if (obj.name == 'Full Credit'){
          strategy['associateRate'] = 100;
          strategy['associateRateName'] = obj.name;
        } else if (obj.name == 'N/A'){
          strategy['associateRate'] = 0;
          strategy['associateRateName'] = obj.name;
        } else {
          strategy['associateRate'] = obj.rate;
          strategy['associateRateName'] = obj.name;
        }
      } else {
        strategy['associateRate'] = 0;
        strategy['associateRateName'] = '';
      }
    });
  }

  setStateAssociatedRateForStrategy() {
    const base = this;
    _.each(this.listOfStrategies, function (strategy) {
      const rates = base.stateAssociatedData || [];
      const obj = _.find(rates, {id: strategy.stateAssociatedWith});
      if (obj){
        if (obj.name === 'Full Credit') {
          strategy['stateAssociateRate'] = 100;
          strategy['stateAssociateRateName'] = obj.name;
        } else if (obj.name === 'N/A') {
          strategy['stateAssociateRate'] = 0;
          strategy['stateAssociateRateName'] = obj.name;
        } else {
          strategy['stateAssociateRate'] = obj.rate;
          strategy['stateAssociateRateName'] = obj.name;
        }
      } else {
        strategy['stateAssociateRate'] = 0;
        strategy['stateAssociateRateName'] = '';
      }
    });
  }

  openIntroductionLetter() {
    this.reveal.introLetter = true;
  }

  hideReveal(key){
    this.reveal[key] = false;
  }

  saveIntroLetter() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.savePlanIntroductionLetter(this.org, this.user.id, this.clientTaxplanData.id, this.introLetter)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Saved successfully');
        this.hideReveal('introLetter');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to perform operation');
      });
  }

  navigateToStrategyInfo(strategy) {
    if (strategy && !strategy.locked){
      this.switchBoard.onDisplayFloatingWindow.next({
        title: 'Strategy Info',
        url: ['tax-planning', 'taxStrategies', strategy.strategyId],
      });
    }
  }

  exportToPDF(){
    let html = jQuery('#custom-report-info').clone().html();
    html = this.getReplacedSpacialCharactersString(html);
    const style = this.getHtmlStyleString();
    const pdfReq = {
      version: '1.1',
      htmlTemplates: [style + html],
      isROIReport: true,
      selectedTextColor: this.selectedTextColor,
      selectedThemeColor: this.selectedThemeColor,
      selectedTheme: this.selectedThemeName,
      footer: moment(new Date()).format('MMMM DD, YYYY HH:mm a')
    };
    const url = '/TaxPlanningServices/orgs/' + this.org + '/users/' + this.user.id + '/export/custom-pdf';
    this.loadingService.triggerLoadingEvent(true);
    this.exportService.exportReportIntoFile(url, pdfReq)
      .subscribe(data => {
        this.loadingService.triggerLoadingEvent(false);
        const blob = new Blob([data], {type: 'application/pdf'});
        const link = jQuery('<a></a>');
        link[0].href = URL.createObjectURL(blob);
        link[0].download = `Tax Planning - ${this.clientTaxplanData.userName}.pdf`;
        link[0].click();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Export Into PDF');
      });
  }

  getHtmlStyleString() {
    let styleString = '';
    const styleHtml = jQuery('style').clone();
    if (styleHtml && styleHtml.length >= 2){
      for (let i = 1; i < styleHtml.length; i++){
        const temp = styleHtml[i].outerHTML;
        if (temp.includes(".placeholder-custom-report-style-tag")){
          styleString += temp;
        }
      }
    }
    return styleString;
  }

  getReplacedSpacialCharactersString(inputString) {
    if (inputString) {
      inputString = inputString.replaceAll("<br>", "<br/>");
      inputString = inputString.replaceAll('“', '"');
      inputString = inputString.replaceAll('”', '"');
      inputString = inputString.replaceAll('‘', "'");
      inputString = inputString.replaceAll('’', "'");
      inputString = inputString.replace(/(<img("[^"]*"|[^/">])*)>/gi, '$1/>');
    }
    return inputString;
  }

  getStrategiesListInfoForPlan() {
    const styleString = this.getHtmlStyleString();
    const html = jQuery('<div>').append(styleString).append(jQuery('#list-of-stretegies').clone()).html();
    return html;
  }

  getStrategyInfoForPlan(index) {
    const styleString = this.getHtmlStyleString();
    const html = jQuery('<div>').append(styleString).append(jQuery('#stretegy-info' + index).clone()).html();
    return html;
  }

  getActualVsPlannedGraphData(){
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getActualProjectedGraphData(this.org, this.user.id, this.taxPlanId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.hasActualVsPLannedGraphData = true;
        let graphData = response;
        const series = [];
        if (response && response.data) {
          _.each(response.data, function(item){
            if (item.name == 'Actual' || item.name == 'Projected') {
              series.push(item);
            }
          });
        }
        this.groupedActualVsPLannedChartOptions = {
          colors: this.chartColors,
          chart: {
            type: 'column',
            style: {
              fontFamily: 'Arial'
            }
          },
          title: {
            text: 'Actual Vs Projected',
            align: 'left',
            style: {
              color: '#100444',
              fontFamily: 'Arial',
              fontSize: '24'
            }
          },
          credits: {
            enabled: false
          },
          xAxis: {
            // type: 'category',
            categories: graphData.strategyNames,
            labels: {
              style: {
                fontSize: '13px',
                fontWeight: 'bold',
                color: '#878787',
                fill: '#878787'
              }
            }
          },
          yAxis: {
            title: {
              text: '',
              style: {
                fontSize: '15px'

              }
            },
            labels: {
              style: {
                fontSize: '13px'

              }
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            column: {
              stacking: 'normal'
            }
          },
          tooltip: {
            formatter: function() {
              return '<b>' + this.x + '</b><br/>' +
                this.series.name + ': ' + base.formatAmount(this.y) + '<br/>';
            }
          },
          series: series,
        };
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get graph data');
      });
  }

  formatAmount(amount){
    return this.numeralService.format('$0,0', amount);
  }

  getROIGraphData() {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getStrategyROIGraphData(this.org, this.user.id, this.taxPlanId, this.roiGraphFilter)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.roiGraphData = response || {};
        this.hasROIGraphData = true;
        this.groupedROIChartOptions = {
          colors: this.chartColors,
          chart: {
            type: 'areaspline',
            style: {
              fontFamily: 'Arial',
              fontWeight: '400'
            }
          },
          title: {
            text: 'Projected Net Tax Savings',
            align: 'left',
            style: {
              color: '#100444',
              fontFamily: 'Arial',
              fontWeight: '300',
              fontSize: '24'
            }
          },
          legend: {},
          xAxis: {
            categories: base.roiGraphData.categories,
            showLastLabel: true
          },
          yAxis: {
            title: {
              text: ''
            },
            labels: {
              formatter: function() {
                if (this.value >= 1E6) {
                  return '$' + (this.value / 1000000).toFixed(2) + 'M';
                }
                return '$' + this.value / 1000 + 'k';
              }
            },
            showLastLabel: true
          },
          credits: {
            enabled: false
          },
          plotOptions: {
            areaspline: {
              fillOpacity: 0.5,
              dataLabels: {
                enabled: true,
                formatter(){
                  return base.formatAmount(this.y);
                }
              },
              enableMouseTracking: false
            }

          },
          series: [{
            name: 'ROI',
            data: base.roiGraphData.data
          }]
        };
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get ROI graph data');
      });
  }

  fillYears(){
    this.filterYears = [];
    let startYear: any = _.toNumber(this.taxYear);
    let endYear: any = startYear + 10;
    for (let i = startYear; i <= endYear; i++){
      this.filterYears.push({id: i.toString(), name: i.toString()});
    }
  }

  filterROIDashboardGraphPage($event){
    this.roiGraphFilter = $event.id;
    this.getROIGraphData();
  }

  exportToDoc() {
    const base = this;
    const strategiesData = _.cloneDeep(this.reportData);
    _.each(strategiesData, (strategy) => {
      strategy.planAmount =  base.formatAmount(strategy.planAmount);
      strategy.taxSavings =  base.formatAmount(strategy.taxSavings);
      strategy.actualAmount =  base.formatAmount(strategy.actualAmount);
      strategy.associatedRate =  strategy.associatedRate + '%';
      strategy.stateTaxSavings =  base.formatAmount(strategy.stateTaxSavings);
      strategy.stateAssociatedRate =  strategy.stateAssociatedRate + '%';
      strategy.clientResourcesHtml = strategy.clientResources ?? '';
    });

    this.stripHTMLData(strategiesData);
    const intro = this.introduction.toArray()[0];
    const data = {
      introLetter: intro?.nativeElement.outerText,
      planName: this.clientTaxplanData.name,
      clientName: (this.clientTaxplanData) ? this.clientTaxplanData.userName : '',
      logoUrl: this.orgLogo,
      planYear: this.taxYear,
      strategies: strategiesData,
      introPageBackground: this.introPageBgUrl,
      dataPageBackground: this.contentPageBgUrl,
      selectedTextColor: this.selectedTextColor,
      selectedThemeColor: this.selectedThemeColor,
      selectedThemeSecColor: this.selectedThemeSecColor,
      selectedTheme: this.isReportingV2Enabled ? this.themeMap[this.selectedThemeName] : this.selectedThemeName,
      overviewStatus: this.overviewStatus,
      todoTaskStatus: this.todoTaskStatus,
      chartOptions: JSON.stringify(this.groupedROIChartOptions),
      disclaimer: this.stripHTML(this.disclaimerApiPost),
      costLines: this.costLines,
      //reportCustomization: this.clientTaxplanData.reportCustomization,
      firmName: this.clientTaxplanData.firmName
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.exportIntoWordDocument(this.org, this.user.id, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        const blob = new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${this.clientTaxplanData.name}.docx`;
        link.click();
        this.taxPlanningService.logReportDownload(this.org, this.user.id, {
          taxPlan: this.clientTaxplanData,
          format: 'word',
          status: 'success',
        }).subscribe();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to export into word document');
        this.taxPlanningService.logReportDownload(this.org, this.user.id, {
          taxPlan: this.clientTaxplanData,
          format: 'word',
          status: 'failure',
          errorMessage: error?.message || 'Unknown error exporting report word document',
        }).subscribe();
      });
  }

  stripHTMLData(strategiesData) {
    const overview = this.clientOverview.toArray();
    const resources = this.clientResources.toArray();
    const todoTemplates = this.todoTemplates.toArray();
    const todoData = {};
    _.each(todoTemplates, (todoTemplate) => {
      const id = todoTemplate.nativeElement.id;
      const splits = id.split("``");
      if (!todoData[splits[1]]) {
        todoData[splits[1]] = {};
      }
      todoData[splits[1]][splits[2]] = todoTemplate.nativeElement.outerText;
    });
    _.each(strategiesData, (strategy) => {
      const tempOverView = _.find(overview, (ov) => {
        return ov.nativeElement.id === 'overview-' + strategy.id;
      });
      const tempResource = _.find(resources, (ov) => {
        return ov.nativeElement.id === 'resource-' + strategy.id;
      });
      _.each(strategy.clientTodos, (clientTodo) => {
        clientTodo.description = todoData[strategy.id]?.[clientTodo.id] || '';
      });
      strategy.clientOverview = (tempOverView) ? tempOverView.nativeElement.outerText : '';
      strategy.clientResources = (tempResource) ? tempResource.nativeElement.outerText : '';
    });
  }


  /* Customize report changes */
  openCustomizeReport() {
    this.showReportCustomize = !this.showReportCustomize;
    if (this.showReportCustomize) {
      this.hasROIGraphData = false;
      this.hasActualVsPLannedGraphData = false;
      this.backgroundType = '100%';
    } else {
      this.backgroundType = "cover";
    }
    setTimeout(() => {
      this.hasROIGraphData = true;
      this.hasActualVsPLannedGraphData = true;
    }, 200);
  }

  onOverviewStatusToggle() {
    this.persistOverviewStatusToSession();
    this.setColorToInstance();
  }

  onTodoTaskStatusToggle() {
    this.setColorToInstance();
  }

  setCustomizedColor(data) {
    if (data && data.type === 'theme') {
      this.selectedThemeColor = data.themeColor;
      if(this.isReportingV2Enabled){
        this.updateBackground();
      }
    } else if (data && data.type === 'text') {
      this.selectedTextColor = data.textColor;
    } else if (data && data.type === 'secondry-theme') {
      this.selectedThemeSecColor = data.secondryThemeColor;
      this.updateBackground();
    }
    this.setColorToInstance();
  }

  resetReportSettings() {
    this.hasReset = false;
    this.selectedThemeColor = '#333333';
    this.selectedTextColor = '#333333';
    // Need to change theme when applying multiple themes based on selected
    // this.introPageBgUrl = 'https://static.taxplaniq.com/report-assets/theme1/bg';
    // this.contentPageBgUrl = 'https://static.taxplaniq.com/report-assets/theme1/bgtheme';
    this.setLayoutValues();
    setTimeout(() => {
      this.hasReset = true;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.top_height = this.reportCustomize.nativeElement.offsetTop;
    }, 1000);
  }

  getReportCustomizationThemes() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getReportCustomInfo(this.org, this.user.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.themeColorsArray = (response.availableThemeColors && response.availableThemeColors.length > 0) ? response.availableThemeColors : this.themeColorsArray;
        this.themeColorsSecArray = (response.availableThemeSecColors && response.availableThemeSecColors.length > 0) ? response.availableThemeSecColors : this.themeColorsSecArray;
        this.textColorsArray = (response.availableTextColors && response.availableTextColors.length > 0) ? response.availableTextColors : this.textColorsArray;
        this.selectedThemeColor = response.themeColor || '#1a1d1f';
        this.selectedThemeSecColor = response.selectedThemeSecColor || this.selectedThemeSecColor;
        this.selectedTextColor = response.textColor;
        this.selectedThemeName = response.themeName || 'theme1';
        const sessionOverviewStatus = this.getOverviewStatusFromSession();
        if (typeof response.overviewStatus === 'boolean') {
          this.overviewStatus = response.overviewStatus;
        } else if (sessionOverviewStatus !== null) {
          this.overviewStatus = sessionOverviewStatus;
        } else {
          this.overviewStatus = false;
        }
        if (typeof response.todoTaskStatus === 'boolean') {
          this.todoTaskStatus = response.todoTaskStatus;
        } else if (typeof response.TodoTaskStatus === 'boolean') {
          this.todoTaskStatus = response.TodoTaskStatus;
        } else {
          this.todoTaskStatus = false;
        }
        this.persistOverviewStatusToSession();
        let color = _.cloneDeep(response.themeColor);
        this.setLayoutValues();
        if(this.isReportingV2Enabled){
          this.updateBackground();
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to get report info');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get report info');
        }
      });
  }

  setLayoutValues() {
    if (this.selectedThemeColor) {
      let color = _.cloneDeep(this.selectedThemeColor);
      this.introPageBgUrl = `https://static.taxplaniq.com/report-assets/${this.selectedThemeName}/bg` + `-` + color.replace('#', '') + '.svg';
      this.contentPageBgUrl = `https://static.taxplaniq.com/report-assets/${this.selectedThemeName}/bgtheme` + `-` + color.replace('#', '') + '.svg';
      this.layout1Url = 'https://static.taxplaniq.com/report-assets/theme1/bg' + '-' + color.replace('#', '') + '.svg';
      this.layout2Url = 'https://static.taxplaniq.com/report-assets/theme2/bg' + '-' + color.replace('#', '') + '.svg';
      this.layout3Url = 'https://static.taxplaniq.com/report-assets/theme3/bg' + '-' + color.replace('#', '') + '.svg';
    }
  }

  addCustomizedColorToArray(data) {
    if (data && data.type === 'theme') {
      this.themeColorsArray.push(data.themeColor);
      this.themeColorsArray = _.uniq(this.themeColorsArray);
      this.selectedThemeColor = data.themeColor;
    }else if (data && data.type === 'secondry-theme') {
      this.themeColorsSecArray.push(data.themeColor);
      this.themeColorsSecArray = _.uniq(this.themeColorsSecArray);
      this.selectedThemeSecColor = data.themeColor;
    } else if (data && data.type === 'text') {
      this.textColorsArray.push(data.textColor);
      this.selectedTextColor = data.textColor;
    }
    this.addColor();
  }

  addColor() {
    const data = {
      themeName: this.selectedThemeName,
      themeColor: this.selectedThemeColor,
      textColor: this.selectedTextColor,
      selectedThemeSecColor: this.selectedThemeSecColor,
      overviewStatus: this.overviewStatus,
      todoTaskStatus: this.todoTaskStatus,
      availableThemeColors: this.themeColorsArray,
      availableTextColors: this.textColorsArray,
      availableThemeSecColors: this.themeColorsSecArray

    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.addColorToReportCustomColors(this.org, this.user.id, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.setColorToInstance();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to add new color');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to add new color');
        }
      });
  }

  setColorToInstance() {
    const data = {
      themeName: this.selectedThemeName,
      themeColor: this.selectedThemeColor,
      selectedThemeSecColor: this.selectedThemeSecColor,
      textColor: this.selectedTextColor,
      availableThemeColors: this.themeColorsArray,
      availableTextColors: this.textColorsArray,
      availableThemeSecColors: this.themeColorsSecArray,
      overviewStatus: this.overviewStatus,
      todoTaskStatus: this.todoTaskStatus,
    };
    let color = _.cloneDeep(this.selectedThemeColor);
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.addColorToInstance(this.org, this.user.id, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.setLayoutValues();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed set theme color');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed set theme color');
        }
      });
  }
  saveLayoutChanges() {
    this.setColorToInstance();
  }

  strategiesInRowsOfThree() {
    const rows: string[][] = [];
    this.listOfStrategies.forEach((item, index) => {
      item.indexNumber = index < 9 ? '0' + (index + 1) : (index + 1).toString();
    });
    for (let i = 0; i < this.listOfStrategies.length; i += 3) {
      rows.push(this.listOfStrategies.slice(i, i + 3));
    }
    this.strategiesForExport = rows;
    return rows;
  }

  changeLayout(themeName) {
    this.selectedThemeName = themeName;
    this.setLayoutValues();
    this.addColor();
    if(this.isReportingV2Enabled){
      this.updateBackground();
    }
  }

   stripHTML(html: string): string {
    if (!html) return '';
    // Replace <p> and </p> with newlines for spacing
    let formattedHtml = html
      .replace(/<\/p\s*>/gi, '\n')
      .replace(/<p\s*>/gi, '')
      .replace(/<br\s*\/?>/gi, '\n');

    const div = document.createElement('div');
    div.innerHTML = formattedHtml;

    return div.textContent?.trim() || '';
    }


    updateBackground() {
      // Get templates from factory
      const templates = SVG_TEMPLATES[this.selectedThemeName] || SVG_TEMPLATES['theme1'];
      const topSvg = templates.top(this.selectedThemeColor, this.selectedThemeSecColor);
      const bottomSvg = templates.bottom ? templates.bottom(this.selectedThemeColor, this.selectedThemeSecColor) : null;
      const contentSvg = templates.content(this.selectedThemeColor, this.selectedThemeSecColor);

      const topSectionurls = [`url("${this.toBase64(topSvg)}")`];
      if (bottomSvg) {
        topSectionurls.push(`url("${this.toBase64(bottomSvg)}")`);
      }

      this.topMainSvg = this.sanitizer.bypassSecurityTrustStyle(topSectionurls.join(', '));
      this.contentSvg = this.sanitizer.bypassSecurityTrustStyle(`url("${this.toBase64(contentSvg)}")`);
    }

    private toBase64(svg: string): string {
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
    }

    scrollTo(sectionId: string) {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }

 /**
 * Combines Top, Bottom, and Content SVGs into one preview string
 */
  getFullThemePreview(themeName: string): SafeStyle {
    const templates = SVG_TEMPLATES[themeName] || SVG_TEMPLATES['theme1'];
    const color = this.selectedThemeColor
    const secColor = this.selectedThemeSecColor;

    const top = templates.top(color, secColor);
    const bottom = templates.bottom(color, secColor) || '';
    const content = templates.content(color, secColor);

    // We wrap them in a single SVG container or stack them
    // This approach stacks them vertically in a preview window
    const combinedSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="300" viewBox="0 0 1123 1800" fill="white">
      <rect width="1123" height="1800" fill="white"/>
      
      <g>
        <g>${top}</g>
        
        ${bottom ? `<g transform="translate(0, 350)">${bottom}</g>` : ''}
        
        <g transform="translate(0, 1710)">${content}</g>
      </g>
    </svg>`;

    return this.sanitizer.bypassSecurityTrustResourceUrl(this.toBase64(combinedSvg));
  }

  hexToRgba(hex: string, opacity: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

  private getOverviewStatusStorageKey(): string {
    const planId = this.clientTaxplanData?.id || this.taxPlanId || 'default-plan';
    return `report-overview-status::${this.org}::${this.user?.id}::${planId}`;
  }

  private getOverviewStatusFromSession(): boolean | null {
    try {
      const storedValue = localStorage.getItem(this.getOverviewStatusStorageKey());
      if (storedValue === 'true') {
        return true;
      }
      if (storedValue === 'false') {
        return false;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  private persistOverviewStatusToSession(): void {
    try {
      localStorage.setItem(this.getOverviewStatusStorageKey(), String(this.overviewStatus));
    } catch (e) {
      // no-op
    }
  }

  private restoreOverviewStatusFromSession(): void {
    const storedValue = this.getOverviewStatusFromSession();
    if (storedValue !== null) {
      this.overviewStatus = storedValue;
    }
  }

}
